














import AbpBase from "@/lib/abpbase";
import { Component, Prop } from "vue-property-decorator";
import dialogFormItems from "../dialogFormItems.vue";

@Component({
    components: { dialogFormItems },
})
export default class extends AbpBase {
    @Prop() eleList;
    formsVal: any = {};

    // 表单验证方法
    valueCheck() {
        const promises = [];
        for (const key of this.eleList.list) {
            if (key.required) {
                if (key.defaultValue instanceof Array) {
                    if (key.defaultValue.length === 0) {
                        if (key.requiredMsg) {
                            promises.push(Promise.reject(key.requiredMsg));
                        } else {
                            promises.push(Promise.reject(`${key.name}必填`));
                        }
                    }
                } else {
                    if (!key.defaultValue) {
                        if (key.requiredMsg) {
                            promises.push(Promise.reject(key.requiredMsg));
                        } else {
                            promises.push(Promise.reject(`${key.name}必填`));
                        }
                    }
                }
            } else {
                promises.push(Promise.resolve());
            }
        }
        return promises;
    }

    getFormVal() {
        return new Promise((resolve, reject) => {
            Promise.all(this.valueCheck())
                .then((res) => {
                    // 读取数据前先清空表单数据
                    this.formsVal = {};
                    // 循环读取表单数据
                    for (const key of this.eleList.list) {
                        Object.assign(this.formsVal, {
                            [key.model]: key.defaultValue,
                        });
                    }
                    resolve(this.formsVal);
                })
                .catch((err) => {
                    this.$message.error(err);
                    reject();
                });
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/formBuilder/formGenerator/index.vue